import React from 'react';
import { Alert } from 'src/@vymo/ui/blocks';
import { ReactComponent as NotificationIcon } from 'src/assets/icons/horn.svg';
import WelcomeCard from './welcomeBanner';
import styles from './index.module.scss';

function VymoBanner() {
  return (
    <Alert
      classNames={styles.welcomeBanner}
      icon={<NotificationIcon />}
      closeable
    >
      <WelcomeCard />
    </Alert>
  );
}

export default VymoBanner;
